import React from 'react'
import {findDOMNode} from "react-dom"

import Popover from "../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../gd-components/gd-popover/popover-position"
import TimeSelectorPopoverContent from "./popover-content"
import DatetimeUtils from "../../../gd/utils/datetime-utils"
import Format from "../../../gd/utils/format"
import Moment from 'moment'

type Props = {
    renderType?         : 'default' | 'standalone'

    className?          : string
    children?           : any

    form?               : any                   // form manager
    name?               : string                 // name of the form field

    placeholderText?    : string
    minValue?           : any
    value?              : any
    timeStep?           : number                 // minutes
    popoverMinWidth?    : number

    onChange?           : callback
}

type State = {
    showPopover: boolean
}

const popoverPosition = PopoverPosition.bottomLeftHorizontal()

export default class TimePicker extends React.Component<Props, State> {
    static defaultProps: Partial<Props> = {
        renderType: 'default',

        placeholderText: 'Select time',
        value: Moment(),
        timeStep: 15,
    }

    state: State = {
        showPopover: false
    }

    constructor(props:Props) {
        super(props)

        if (this.props.form) this.props.form.registerFormComponent(this.props.name,this)
    }

    togglePopover = (e:any) => {
        e.stopPropagation()
        this.setState({
            showPopover: !this.state.showPopover
        })
    }

    hidePopover = () => {this.setState({showPopover: false})}

    onOptionClick = (value:any) => {
        if (this.props.form) this.props.form.onFormComponentValueChange(this.props.name,value)

        this.setState({
            showPopover: false
        }, ()=>{
            if (this.props.onChange) this.props.onChange(value)
        })
    }

    _getValue = () => {
        const value = this.props.form ? this.props.form.getValue(this.props.name) : this.props.value
        return value ? DatetimeUtils.stickToSteps(value, this.props.timeStep) : null
    }

    renderPopover() {
        if (this.state.showPopover) {
            const minValue = this.props.minValue ? DatetimeUtils.stickToSteps(this.props.minValue) : null

            return (
                <Popover className="gd-time-picker-popover-content"
                         position       = {popoverPosition}
                         onClickOutside = {()=>{this.hidePopover()}}
                         getTargetFunc  = {()=>findDOMNode(this)}>
                    <TimeSelectorPopoverContent selectedValue={this._getValue()}
                                                timeStep={this.props.timeStep}
                                                minValue={minValue}
                                                popoverMinWidth={this.props.popoverMinWidth}
                                                onOptionClick={this.onOptionClick}/>
                </Popover>
            )
        }
    }

    renderValue() {
        const value = this._getValue()
        return value ? Format.timeUserFormat(value) : this.props.placeholderText
    }

    render() {
        switch (this.props.renderType) {
            case "standalone":
                return (
                    <div className={Classes("gd-time-picker", "ui5-txt-default", this.props.className)} onClick={this.togglePopover}>
                        <div className="ui5-ico-12 i5-my-time m-r-10"/>
                        <div className="txt">{this.renderValue()}</div>
                        {this.renderPopover()}
                        {this.props.children}
                        <div className="ui5-arrow-toggle s8 open m-l-10"/>
                    </div>
                )

            default:
                return (
                    <div className={Classes("gd-time-picker", "default-render-type", this.props.className)} onClick={this.togglePopover}>
                        {this.renderValue()}
                        {this.renderPopover()}
                        {this.props.children}
                        <div className="arrow ui5-arrow-toggle s11 open"/>
                    </div>
                )
        }
    }
}
